import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../component/Header";
import BottomNav from "../component/BottomNav";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";

import SearchBookList from "../component/SearchBookList";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

class Search extends Component {
	
	constructor(props) {
		super(props);

		this.state = { headerTitle: "더책", totalcount: 0, curpageidx: 0, sortway: 1, sortorder: 1, booklist: [], loading: true };

		this.getData(true, "");
	}

	handleChange(event) {

		const strinput = event.target.value;

		//string text = "마암ㄴ어ㅏㅘㅓㅁ아234";
		//string outText = string.Empty;

		/*
		var bsuccharacters = true;

		foreach(c in strinput)
		{
			// whitelist 방식 validation 
			if (c >= 'a' && c <= 'z') {  // 영어 소문자 
				outText += c;
			}
			else if (c >= 0xAC00 && c <= 0xD7AF) { // 한글
				outText += c;
			}
			else {
				
			}
		}
		*/

		var query = event.target.value;
		console.log("searchstring: " + query);
		this.getData(true, query);
		query += " ";
		this.getData(true, query);
	}

	getData(binit, strquery) {
		console.log(binit + ", " + this.state.curpageidx + ", " + this.state.totalcount);

		if (binit === false && this.state.booklist.length >= this.state.totalcount)
			return;
		this.state.loading = true;

		//console.log("aaa: " + strquery + ", " + this.prevState);

		this.state.query = strquery;
		if (binit === true) {
			this.state.curpageidx = 0;
		}

		fetch(`/api/AB/BookList?pgidx=${this.state.curpageidx}&pgsize=50&search=${strquery}`)
			.then(response => response.json())
			.then(data => {

				this.state.loading = false;

				if (binit === true) {
					this.state.curpageidx = 0;
					this.state.booklist = data.lstresult;
					this.state.curpageidx++;
				}
				else {
					this.state.curpageidx++;
					this.state.booklist.push(...data.lstresult);
				}
				
				//const booklist = data.lstresult;

				this.setState({ totalcount: data.totalcount, curpageidx: this.state.curpageidx, booklist: this.state.booklist, loading: false });
				//this.render();
			});
	};

	componentWillMount() {
		var self = this;
		window.addEventListener('scroll', function () {
			if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
				console.log("you're at the bottom of the page");
				if (self.state.loading === false) {
					self.getData(false, self.state.query);
				}
			}
		});
	}

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
        this.logPageView();

		//let contents = this.state.loading === true ? "loading..." : this.dorender();
		let contents = "loading...";

		return (
			<React.Fragment>
				<Header headerTitle={this.state.headerTitle} />
				<div className="searchBar">
					<input className="form-input" placeholder="검색어를 입력해 주세요" type="text" onChange={this.handleChange.bind(this)} value={this.state.searchword}/>
				</div>
	
				<div className="section-body">
					<React.Fragment>
						<ul className="bookList">
							{this.state.booklist.map((book, index) => {
								return (
									<React.Fragment>
										<li className="bookList-item">
											<Link to={`/book/${book.id}`}>
												<div className="bookList-thumbnail">
													<div className="thumbnail">
														<img
															className="thumbnail-image"
															src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.id}`}
															alt={book.subject}
														/>
													</div>
												</div>
												<div className="bookList-info">
													<h3 className="bookList-title">{book.subject}</h3>
													<h4 className="bookList-author">{book.authorName}</h4>
													<h4 className="bookList-publisher">{book.publisherName}</h4>
												</div>
											</Link>
										</li>
									</React.Fragment>
								);
							})}
						</ul>
					</React.Fragment>
					
				</div>

				<BottomNav />
			</React.Fragment>
		);
	}
}

export default Search;
